import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getBookingList, addKundaliServ } from "../../services/appointment.service";
import Skeleton from "react-loading-skeleton";
import { useGlobalState } from "../../GlobalProvider";
import TableNav from "../../components/TableNav";
import moment from "moment";
import NoRecordFound from "../../components/NoRecordFound";
function VisitConfirmation() {
  const [showSkelton, setShowSkelton] = useState(false);
  const [list, setList] = useState([]);

  const handleGetBookingList = async () => {
    setShowSkelton(true);
    try {
      let response = await getBookingList({ status: "scheduled" });
      if (response?.data?.success) {
        const filterTodayData = response?.data?.data?.filter((v, i) => {
          return v?.scheduledDate == moment().format("YYYY-MM-DD");
        });
        setList(filterTodayData);
      }
    } catch (error) {
      console.log(error);
    }
    setShowSkelton(false);
  };
  useEffect(() => {
    handleGetBookingList();
  }, []);
  const [popupDetails, setPopUpDetails] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    birthTime: "",
    birthLocation: "",
    bookingId: "",
  });
  const handleAddKundaliFunc = async () => {
    setBtnLoader(true)
    try {
      let response = await addKundaliServ(formData);
      if (response?.data?.statusCode == 200) {
        setFormData({
          name: "",
          dob: "",
          birthTime: "",
          birthLocation: "",
          bookingId: "",
        });
        setPopUpDetails(null)
        toast.success(response?.data?.message);
        handleGetBookingList();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Internal Server Error");
    }
    setBtnLoader(false)
  };
  const [showKundaliForm, setShowKundaliForm] = useState(true);
  const [btnLoader, setBtnLoader]=useState(false)
  return (
    <div className="main_layout  bgBlack d-flex">
      {/* sectionLayout started */}
      <section className="section_layout d-flex">
        {/* sidebar started */}
        <Sidebar selectedItem="Visit Confirmation" />
        {/* sidebar ended */}
        <div className="w-100 me-5">
          <div className="ms-5 w-100">
            <div className="">
              <div className="tableBody borderRadius50All">
                <div>
                  <table className="table ">
                    <thead>
                      <tr style={{ background: "#1E4D91", color: "#fff" }}>
                        <th scope="col" style={{ borderRadius: "24px 0px 0px 24px" }}>
                          <div className="d-flex justify-content-center ms-2">
                            <span className="mx-2">Sr. No</span>
                          </div>
                        </th>
                        <th scope="col">Location</th>
                        <th scope="col">Full Name</th>

                        <th scope="col">Contact Number</th>
                        <th scope="col">City</th>
                        <th scope="col">No. of kundali</th>

                        <th scope="col">Extra Time</th>
                        <th scope="col">Token Number</th>
                        <th scope="col">Schedule Time</th>

                        <th scope="col" style={{ borderRadius: "0px 24px 24px 0px" }}>
                          Action
                        </th>
                      </tr>
                    </thead>

                    <div className="pt-3 pb-2 "></div>
                    <tbody className="driverTable">
                      {showSkelton
                        ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((v, i) => {
                            return (
                              <tr className=" ">
                                <td>
                                  <Skeleton width={40} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                              </tr>
                            );
                          })
                        : list?.map((v, i) => (
                            <>
                              <tr key={i} style={{ background: "#E7E7E7", cursor: "pointer", border: "2px solid red" }}>
                                <td scope="row" style={{ borderRadius: "12px 0px 0px 12px" }}>
                                  {i + 1}
                                </td>
                                <td>{v?.location}</td>
                                <td>{v?.fullName}</td>
                                <td>
                                  {v?.countryCode} {v?.contact}
                                </td>
                                <td>{v?.yourCity}</td>
                                <td>
                                  {v?.noOfKundali} {`(${v?.kundaliDetails?.length || 0}  added)`}
                                </td>
                                <td>{v?.extraTime ? v?.extraTime : 0} mins</td>
                                {/* <td> {moment(v?.scheduledDate).format("DD/MM/YYYY")}</td> */}

                                <td>{v?.tokenNo}</td>
                                <td>{v?.scheduledTime}</td>
                                <td style={{ borderRadius: "0px 12px 12px 0px" }}>
                                  <button
                                    className="btn btn-primary me-3"
                                    style={{
                                      marginTop: "-6px",
                                      background: "#7650E0",
                                      borderRadius: "6px",
                                      border: "none",
                                      width: "80px",
                                    }}
                                    onClick={() => {
                                      setPopUpDetails(v);
                                      setFormData({ ...formData, bookingId: v?._id });
                                    }}
                                  >
                                    View
                                  </button>
                                </td>
                              </tr>
                              <div className="py-2"></div>
                            </>
                          ))}
                    </tbody>
                  </table>
                  {list?.length == 0 && !showSkelton && <NoRecordFound theme="light" />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* sectionLayout ended */}
      {popupDetails?._id && (
        <div
          className="modal fade show d-flex align-items-center appointmentPopup  justify-content-center "
          tabIndex="-1"
        >
          <div className="modal-dialog">
            <div
              className="modal-content"
              style={{ borderRadius: "16px", background: "#f7f7f5", height: "600px", width: "600px" }}
            >
              <div className="d-flex justify-content-end pt-4 pb-0 px-4">
                <i
                  className="fa fa-close text-secondary"
                  onClick={() => {
                    setPopUpDetails(null);
                  }}
                ></i>
              </div>

              <div className="modal-body">
                <div
                  style={{
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                  className="d-flex justify-content-center w-100"
                >
                  {!showKundaliForm ? (
                    <div className="w-100 px-2">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="mb-0">Kundali Details</h3>
                        <div className="btn btn-sm btn-primary" onClick={() => setShowKundaliForm(true)}>
                          Add More
                        </div>
                      </div>

                      {popupDetails?.kundaliDetails?.map((v, i) => {
                        return (
                          <div
                            className="p-3 border shadow-sm  mb-3"
                            style={{ background: "#F0B6BA", borderRadius: "12px" }}
                          >
                            <p>
                              <b>Name</b> : {v?.name}
                            </p>
                            <p>
                              <b>Date of Birth</b> : {v?.dob}
                            </p>
                            <p>
                              <b>Birth Time</b> : {v?.birthTime}
                            </p>
                            <p className="mb-0">
                              <b>Birth Location</b> : {v?.birthLocation}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="w-100 px-2">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="mb-0">Kundali Details</h3>
                        <div className="btn btn-sm btn-primary" onClick={() => setShowKundaliForm(false)}>
                          View Card
                        </div>
                      </div>
                      <label>Enter Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData?.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      />
                      <label>Enter Date of Birth</label>
                      <input
                        type="date"
                        className="form-control"
                        value={formData?.dob}
                        onChange={(e) => setFormData({ ...formData, dob: e.target.value })}
                      />
                      <label>Enter Birth Time</label>
                      <input
                        type="time"
                        className="form-control"
                        value={formData?.birthTime}
                        onChange={(e) => setFormData({ ...formData, birthTime: e.target.value })}
                      />
                      <label>Enter Birth Location</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData?.birthLocation}
                        onChange={(e) => setFormData({ ...formData, birthLocation: e.target.value })}
                      />
                      {formData?.name && formData?.dob && formData?.birthTime && formData?.birthLocation ? (
                        btnLoader ? <button style={{opacity:"0.5"}}>Saving ...</button> : <button onClick={handleAddKundaliFunc}>Submit</button>
                      ) : (
                        <button style={{ opacity: "0.5" }}>Submit</button>
                      )}
                    </div>
                  )}
                </div>
                <div className="d-flex justify-content-center"></div>
              </div>
            </div>
          </div>
        </div>
      )}
      {popupDetails?._id && <div className="modal-backdrop fade show"></div>}
    </div>
  );
}

export default VisitConfirmation;
